'use client'

import { useRouter } from 'next/navigation'
import { useLocale } from 'next-intl'

import { redirectToPortal as _redirectToPortal } from '@common/utils/redirectToPortal'

import { navigateOrRedirect as _navigateOrRedirect } from '../utils/navigateOrRedirect'
import { navigateTo as _navigateTo } from '../utils/navigateTo'

export function useNavigateTo({ isPortal }: { isPortal: boolean }) {
  const locale = useLocale()
  const router = useRouter()

  const navigateTo = (path: string) => _navigateTo(path, router, locale)
  const redirectToPortal = (path: string) => _redirectToPortal(path, locale)
  const navigateOrRedirect = (route: string) => _navigateOrRedirect(route, isPortal, navigateTo, redirectToPortal)

  return { navigateTo, redirectToPortal, navigateOrRedirect, router, locale }
}
